import React from 'react';
import { useAgencyDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/AgencyDashboard/store/agencyDashboard.store';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/OverviewDashboard.styled';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';

export const AgencyShiftsByPositionChart: React.FC = () => {
  const data = useAgencyDashboardStore((s) => s.shiftsByPosition);
  const page = useAgencyDashboardStore((s) => s.shiftsByPositionPage);
  const totalPages = useAgencyDashboardStore((s) => s.shiftsByPositionTotalPages);
  const loadingMore = useAgencyDashboardStore((s) => s.shiftsByPositionLoadingMore);
  const loadMore = useAgencyDashboardStore((s) => s.loadMoreShiftsByPosition);
  const palette = useChartColors();

  if (!data || data.length === 0) {
    return (
      <EmptyStateContainer>
        No agency shift data available for the selected filters.
      </EmptyStateContainer>
    );
  }

  const barColor = palette.chartColors[0];

  const items: HorizontalBarItem[] = data.map((d) => {
    const hours = formatDashboardNumber(d.hours);
    const shifts = d.shiftCount.toLocaleString();
    return {
      label: d.position,
      value: d.shiftCount,
      valueLabel: `${shifts} shifts · ${hours} hrs`,
      ariaLabel: `${d.position}: ${shifts} agency shifts, ${hours} hours`,
      tooltipHtml: `<strong>${d.position}</strong><br/>Agency shifts: ${shifts}<br/>Hours: ${hours}`,
      barColor,
    };
  });

  return (
    <HorizontalBarChart
      items={items}
      leftMargin={170}
      rightMargin={150}
      showTrack={false}
      wrapLabels
      scrollable
      ariaLabel="Agency shifts by position chart showing agency shift count and hours per position"
      onLoadMore={loadMore}
      hasMore={page < totalPages}
      isLoadingMore={loadingMore}
    />
  );
};
